import React from 'react';
import { Form } from 'react-bootstrap';

const DateSelector = ({ startDate, setStartDate }) => {
  return (
    <div style={{ marginTop: 8 }}>
      <div>
        <Form.Group className="mb-3">
          <div className="d-flex align-items-center mb-2">
            <Form.Label className="fw-bold text-white mb-0">Start Date</Form.Label>
          </div>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="bg-dark text-white  bg-primary  border-secondary"
          />
        </Form.Group>
      </div>
    </div>
  );
};

export default DateSelector;
